import {
  EU_STORE_CONFIG,
  EU_TOPSHOP_BASE_URL,
  GB_TOPSHOP_BASE_URL,
} from "@/constants/static-constants";

export type HreflangLink = {
  hrefLang: string;
  href: string;
};

type GenerateHreflangLinksOptions = {
  gbPath?: string;
  euPath?: string;
  includeGbDefaults?: boolean;
};

export const generateHreflangLinks = (
  options: GenerateHreflangLinksOptions = {},
): HreflangLink[] => {
  const { gbPath = "", euPath = "", includeGbDefaults = true } = options;

  const links: HreflangLink[] = [];

  if (includeGbDefaults) {
    const gbUrl = `${GB_TOPSHOP_BASE_URL}${gbPath}`;
    links.push(
      { hrefLang: "x-default", href: gbUrl },
      { hrefLang: "en-GB", href: gbUrl },
      { hrefLang: "en", href: gbUrl },
    );
  }

  const euLinks = EU_STORE_CONFIG.map(({ code, path }) => {
    const hrefLang = path ? path : `en-${code}`;
    const localeSegment = path ? `/${path}` : "";

    return {
      hrefLang,
      href: `${EU_TOPSHOP_BASE_URL}${localeSegment}${euPath}`,
    };
  });

  return [...links, ...euLinks];
};
